import { UserGroupIcon } from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Employee Directory",
    href: "/employee-directory",
    icon: UserGroupIcon,
    current: false,
    internalName: "employee_directory",
    permissions: ["employee-directory"],
  },
];

const employeeDirectoryConfig = {
  sectionName: "employee-directory",
  defaultRoute: "/employee-directory",
  navigation,
};

export default employeeDirectoryConfig;
